import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '@core/components/components.module';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@core/shared.module';

import { LoginComponent } from './components/login/login.component';
import { TimeoutComponent } from './components/timeout/timeout.component';

@NgModule({
  declarations: [LoginComponent, TimeoutComponent],
  imports: [CommonModule, ComponentsModule, CoreModule, SharedModule],
})
export class AuthModule {}
